import Styles from './Pill.module.scss'
import { PillProps } from 'components/Pill/Types'
import cx from 'classnames'
import { filterDOMProps } from '@react-aria/utils'

export const Pill = ({ size = 'md', children, className, style, ...props }: PillProps) => (
  <div
    className={cx(Styles.pill, Styles[size], className)}
    style={style}
    {...filterDOMProps(props, { labelable: true })}
  >
    {children}
  </div>
)
